import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";
export const GET_ENV_VARIABLE = "GET_ENV_VARIABLE";

export const service = async (dashboardUrl) => {
  const options: object = {
    url: `/api/ReportPackage/GetEnvVariable/` + dashboardUrl,
    method: "GET",
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_ENV_VARIABLE, service, mock);
